
export const scorecard = "Scorecard2013";

export const CreateScorecard = `${scorecard}/CreateEEScorecard`;
export const UpdateScorecard = `${scorecard}/UpdateEEScorecard`;
export const GetGeneralInformation = `${scorecard}/GetEEScorecardGeneralInfo`;
export const ScorecardCopy = 'EmploymentEquity/Scorecard/Copy'
export const CreateNewEEConsolidatedScorecard = `${scorecard}/CreateNewEEConsolidatedScorecard`;
export const ConsolidateScorecard = 'EmploymentEquity/Scorecard/Consolidate';
export const ReConsolidateScorecard = 'EmploymentEquity/Scorecard/ReConsolidate/';
export const SearchConsolidationHistory = 'EmploymentEquity/Scorecard/Search';
export const ScorecardsInConsolidation = '/Consolidations/ScorecardsInConsolidation'
export const CheckScorecardType = `${scorecard}/CheckScorecardType`;
export const GetScorecardMeta = 'EmploymentEquity/Scorecard/GetScorecardMeta/';
export const GetConsolidationRulesMap = 'EmploymentEquity/Scorecard/GetConsolidationRulesMap/';
export const GetConflicts = 'EmploymentEquity/Scorecard/Conflicts/';
export const ResolveConflicts = 'EmploymentEquity/Scorecard/ResolveConflicts/';
export const ValidateEEConsolidationScorecardName = `${scorecard}/ValidateEEConsolidationScorecardName`;
export const AutoResolveConflicts = 'EmploymentEquity/Scorecard/AutoResolveConflicts/';
